import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SaveChangesService {
  private readonly hasChangesSubject = new BehaviorSubject<boolean>(false);
  public readonly hasChanges$ = this.hasChangesSubject.asObservable();
  private readonly notificationSubject = new BehaviorSubject<string>(
    undefined
  );
  public readonly notification$ = this.notificationSubject.asObservable();

  setHasChanges(changes: boolean): void {
    this.hasChangesSubject.next(changes);
  }

  get hasChanges(): boolean {
    return this.hasChangesSubject.value;
  }

  notify(url: string): void {
    this.notificationSubject.next(url);
  }
}
